import { growthplateLogout, logoutApi } from '@/api/modules/login';
import { GlobalStore } from '@/store';
import { StudyStore } from '@/store/modules/study';

export const requestGrowthplateLogout = async () => {
	const response = await growthplateLogout();
	console.log('growthplateLogout API response ===', response);
	const resData = response?.data?.data;
	if (response?.data?.statusCode === '200') {
		const globalStore = GlobalStore();
		let dataToSend = {
			systemId: resData?.systemId,
			sbjgrpId: resData?.sbjgrpId,
			sbjgrpSeq: resData?.sbjgrpSeq,
			kunnr: encodeURI(resData?.kunnr),
			loginSeq: resData?.loginSeq,
			scenarioSeq: resData?.scenarioSeq,
			accessToken: encodeURI(resData?.accessToken),
			scenarioLvlSeq: resData?.scenarioLvlSeq,
			ustudyActSeq: resData?.ustudyActSeq,
			zempId: encodeURI(resData?.zempId),
			matnrSeq: resData?.matnrSeq,
			matnr: resData?.matnr,
			zProc: resData?.zProc,
			setNo: resData?.setNo,
			path: 'Main',
		};
		// const jsonStr = JSON.stringify(dataToSend);
		// console.log('jsonStr ===', jsonStr);
		//Growth.sendDataToAndroid(jsonStr);

		window.PanApp.sendErrToAndroid('Home');

		// globalStore.setToken(null);
		// globalStore.setReToken(null);
		// globalStore.setAudience('');
		// globalStore.setLogoutPath('');
	}
};

export const requestGrowthplateRightNowLogout = async () => {
	const globalStore = GlobalStore();
	let dataToSend = {
		systemId: globalStore.growthData?.systemId,
		sbjgrpId: globalStore.growthData?.sbjgrpId,
		sbjgrpSeq: globalStore.growthData?.sbjgrpSeq,
		kunnr: globalStore.growthData?.kunnr,
		loginSeq: globalStore.growthData?.loginSeq,
		scenarioSeq: globalStore.growthData?.scenarioSeq,
		accessToken: globalStore.growthData?.accessToken,
		scenarioLvlSeq: globalStore.growthData?.scenarioLvlSeq,
		ustudyActSeq: '',
		zempId: '',
		matnrSeq: '',
		matnr: '',
		zProc: '',
		setNo: '',
		path: 'Main',
	};
	// const jsonStr = JSON.stringify(dataToSend);
	// console.log('jsonStr ===', jsonStr);
	//Growth.sendDataToAndroid(jsonStr);

	window.PanApp.sendErrToAndroid('Home');

	// globalStore.setToken(null);
	// globalStore.setReToken(null);
	// globalStore.setAudience('');
	// globalStore.setLogoutPath('');
};

/**
 * 앱 성장판 중복 로그인 시 브릿지 함수
 * 앱 login 화면으로 이동
 */
export const duplicatedGrowthplateLogin = () => {
	if (
		typeof Growth !== 'undefined' &&
		typeof Growth.sendErrToAndroid === 'function'
	) {
		Growth.sendErrToAndroid('Duplicated');
	} else {
		requestGrowthplateRightNowLogout();
	}
};

/**
 * 앱 성장판 브릿지 함수(통신 장애)
 * 앱 성장판 Home 화면으로 이동
 */
export const moveGrowthplateHome = () => {
	if (
		typeof Growth !== 'undefined' &&
		typeof Growth.sendErrToAndroid === 'function'
	) {
		Growth.sendErrToAndroid('Home');
	} else {
		requestGrowthplateRightNowLogout();
	}
};

/**
 * 앱 성장판 브릿지 함수 (통신 장애)
 * 앱 성장판 login 화면으로 이동
 */
export const moveGrowthplateLogin = () => {
	if (
		typeof Growth !== 'undefined' &&
		typeof Growth.sendErrToAndroid === 'function'
	) {
		Growth.sendErrToAndroid('Login');
	} else {
		requestGrowthplateRightNowLogout();
	}
};

/**
 * 웹 마카다미아 로그아웃 함수
 */
export const logoutMacadamia = async () => {
	const globalStore = GlobalStore();
	globalStore.initStore();
	window.location.href = process.env.VUE_APP_SSO_LOGOUT_URL;
};

/**
 * 로그아웃 함수
 * if(성장판) = requestGrowthplateLogout(); else(마카다미아) = logoutMacadamia();
 */
export const logout = () => {
	const gStore = GlobalStore();
	const loginRoot = gStore.loginRoot;

	if (loginRoot === 'growthplate') {
		requestGrowthplateLogout();
	} else {
		// window.location.href = isMemberEval ? process.env.VUE_APP_SSO_LOGIN_URL : EVAL_LOGIN;
		/*
			external-login: 외부 접근 로그인  /krt-login
			web: 체험 계정 로그인  /exp-login
			macadamia: 마카다미아 로그인  VUE_APP_SSO_LOGOUT_URL
		*/
		if (loginRoot === 'external-login') {
			window.location.href = '/krt-login';
		} else if (loginRoot === 'web') {
			window.location.href = '/exp-login';
		} else if (loginRoot === 'macadamia') {
			logoutMacadamia();
		}
	}
};

/*
 * backend 중복로그인 처리
 * if(성장판) = 앱 로그인 화면 이동 else(마카다미아) = 마카다미아 로그아웃
 */
export const duplicatedToken = () => {
	const gStore = GlobalStore();
	const loginRoot = gStore.loginRoot;
	// gStore.initStore();
	if (loginRoot === 'growthplate') {
		// requestGrowthplateRightNowLogout();
		duplicatedGrowthplateLogin();
	} else {
		//window.location.href = isMemberEval ? LOGIN : EVAL_LOGIN;
		logoutMacadamia();
	}
};
